<template>
  <CCol sm="12" class="sent-messages-main p-0">
    <CRow class="m-0">
      <CCol sm="6" class="border-right p-0">
        <CCol sm="12" class="p-0">
          <CRow class="m-0 py-2 border-bottom">
            <CCol sm="6">
              <div class="position-relative">
                <label for>Select Role</label>
                <select
                  v-model="role"
                  name
                  id
                  class="form-control"
                  @change="getNotifications(),notificationDetail = null"
                >
                  <option value>Select</option>
                  <option value="patient">Patient</option>
                  <option value="doctor">Doctor</option>
                  <option value="pharmacy">Pharmacy</option>
                  <option value="diagnostics-lab">Diagnostic</option>
                  <option value="bloodbank">Blood Bank</option>
                  <option value="ambulance">Ambulance</option>
                </select>
                <span class="drop-icon">
                  <i
                    aria-hidden="true"
                    class="v-icon mdi mdi-menu-down theme--light position-absolute"
                  ></i>
                </span>
              </div>
            </CCol>
            <CCol sm="6">
              <label for>Select Date</label>
              <input
                type="date"
                v-model="date"
                class="form-control"
                @change="getNotifications(),notificationDetail = null"
              />
            </CCol>
          </CRow>
          <CCol sm="12" class="scroll-div p-0">
            <div
              class="p-3 border-bottom"
              :class="(notificationDetail && notificationDetail._id == notification._id) ? 'active-user' : ''"
              v-for="notification in notifications"
              :key="notification._id"
              @click="notificationDetail = notification"
            >
              <div class="d-flex justify-content-between">
                <h5 class="text-capitalize">{{notification.role}}</h5>
                <small>{{dayJS(notification.created_at).format(formats.date_format)}}</small>
              </div>
              <div>
                <p class="mb-0">
                  {{displayMessage(notification.message)}}
                  <strong
                    class="cursor white-space-nowrap"
                  >View more details</strong>
                </p>
              </div>
            </div>
          </CCol>
          <CPagination
            class="mx-3 mt-4 pagination-block"
            v-if="totalPage > 0"
            align="end"
            :active-page.sync="currentPage"
            :pages="totalPage"
            @update:activePage="changePage"
          />
        </CCol>
      </CCol>

      <!-- .... end col-6 .... -->
      <CCol sm="6" class="p-4" v-if="notificationDetail">
        <div>
          <h5 class="text-capitalize">{{notificationDetail.role}}</h5>
          <div>
            <p class="mb-1">
              <strong>Category</strong>
            </p>
            <div class="mb-3">
              <span v-for="(appliedFilter,index) in notificationDetail.filter" :key="index">
                <span
                  v-if="index == 'is_verified'"
                >{{appliedFilter ? "Verified":"Non verified"}},&nbsp;</span>
                <span
                  v-else-if="index == 'is_relife_member'"
                >{{appliedFilter ? "Relife Member":"Non Relife Member"}},&nbsp;</span>
                 <span
                  v-else-if="index == 'is_attach_to_hospital'"
                >{{appliedFilter ? "Attached To Hospital":"Not Attached To Hospital"}},&nbsp;</span>
                <span
                  v-else-if="index == 'outstation'"
                >{{appliedFilter ? "Outstation":"Not Outstation"}},&nbsp;</span>
                <span
                  v-else-if="index == 'is_generic_store'"
                >{{appliedFilter ? "Generic":"Not Generic"}},&nbsp;</span>
                <span
                  v-else-if="index == 'donor_card'"
                >{{appliedFilter ? "Donor card accepted":"Donor card not accepted"}},&nbsp;</span><span
                  v-else-if="index == 'hospital_delivery'"
                >{{appliedFilter ? "Hospital delivery available":"Hospital delivery not  available"}},&nbsp;</span>
                <span v-else-if="index == 'gender'">{{appliedFilter}},&nbsp;</span>
                <span v-else-if="(typeof appliedFilter == 'object' )" v-for="(filter,i) in appliedFilter" :key ="i" >
                  <span v-if="index == 'specialities'">{{filter.speciality_type}},&nbsp;</span>
                  <span v-else>{{filter.name ? filter.name : filter}},&nbsp;</span>
                </span>
                <span v-else>{{appliedFilter}},&nbsp;</span>

              </span>
            </div>
          </div>
          <div>
            <p class="mb-1">
              <strong>Message</strong>
            </p>
            <p v-html="notificationDetail.message" v-linkified />
          </div>
          <div>
            <p
              class="mb-1"
            >Date : {{dayJS(notificationDetail.created_at).format(formats.date_format)}}</p>
            <p>
              <strong>Notified User - {{notificationDetail.users_count}}</strong>
            </p>
          </div>
          <div v-if="notificationDetail.attachments"  @click="
               openModal()
                 
                ">
            <v-chip>
              <img
                v-if="checkIsPdf(notificationDetail.attachments)"
                src="/img/avatars/file-pdf.png"
                alt="default-user"
                class="mr-2"
                style="width:22px;"
              />
              <img
                v-else
                src="/img/avatars/014-gallery.png"
                alt="default-user"
                class="mr-2"
                style="width:22px;"
              />
              {{ getFilenameFromURL(notificationDetail.attachments) }}
            </v-chip>
          </div>
          <div>
            <image-preview
            @close="closeImageModal"
            v-if="openImageModal"
            :openImageModal="openImageModal"
            :source="notificationDetail.attachments"
            ></image-preview>
          </div>
          {{ notificationDetail.attachments }}
        </div>
      </CCol>
      <!-- .... end col-6 .... -->
    </CRow>
  </CCol>
</template>
<script>
import "@/assets/scss/_systemNotifications.scss";
import { pickSvg } from "@/views/SVG";
import config from "@/config.js";
import formats from "@/formats";
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .isBetween()
  .build();
import linkify from "vue-linkify";
export default {
  directives: {
    linkified: linkify
  },
  data() {
    return {
      currentPage: 1,
      totalPage: 1,
      notifications: [],
      recordsPerPage: 10,
      openImageModal: false,
      role: "doctor",
      formats,
      dayJS,
      date: "",
      notificationDetail: null
    };
  },
  components: {
    ...pickSvg("filterSVG"),
    "image-preview": () => import("@/components/modals/imagePreview.vue"),
  },
  methods: {
    checkIsPdf(url) {
      let extension = url.split(".").pop();
      return extension == "pdf";
    },
    getFilenameFromURL(url) {
      const parsedUrl = new URL(url);
      const pathname = parsedUrl.pathname;
      return pathname.substring(pathname.lastIndexOf("/") + 1);
    },
    openModal() {
      this.openImageModal = true;
    },
    closeImageModal() {
      this.openImageModal = false;
    },
    changePage(currentPage, reduced) {
      this.currentPage = currentPage;
      this.getNotifications();
    },
    getNotifications() {
      let url = `${config.BASE_URL}api/v2/admin/system-notifications`;
      let params = {
        role: this.role,
        page: this.currentPage,
        records_per_page: this.recordsPerPage
      };
      if (this.date != "") {
        params.date = this.date;
      }
      this.$http.get(url, { params: params }).then(response => {
        // this.doctorSpecialities = response.body.data;
        this.notifications = response.body.data.list;
        this.totalPage = response.body.data.count / this.recordsPerPage;
        if (response.body.data.count % this.recordsPerPage !== 0)
          this.totalPage = parseInt(JSON.stringify(this.totalPage)) + 1;
      });
    },
    displayMessage(message) {
      if (message.length > 100) {
        return message.substring(0, 100) + "...";
      }
      return message;
    }
  },
  mounted() {
    this.getNotifications();
  }
};
</script>